import { render, staticRenderFns } from "./returnJk.vue?vue&type=template&id=484bb57e&"
import script from "./returnJk.vue?vue&type=script&lang=js&"
export * from "./returnJk.vue?vue&type=script&lang=js&"
import style0 from "./returnJk.vue?vue&type=style&index=0&id=484bb57e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports